import React, { useState } from 'react';
import { Form, Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setPosition } from 'reducers/livingCarbonGrantReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SearchAreaControl = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = async () => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${searchValue}&limit=1`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch location data');
      }
      const data = await response.json();

      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        const position = [parseFloat(lat), parseFloat(lon)];
        dispatch(setPosition(position));
      } else {
        throw new Error('Location not found');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent form submission
      handleSearch();
    }
  };

  return (
    <Dropdown className="search-box">
      <Dropdown.Toggle
        as="div"
        className="dropdown-caret-none"
      ></Dropdown.Toggle>
      <Form className="position-relative">
        <Form.Control
          type="search"
          placeholder="Enter address, please"
          aria-label="Search"
          className="rounded-pill search-input"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          onKeyDown={handleKeyDown} // Call handleSearch on Enter key press
        />
        <FontAwesomeIcon
          icon="search"
          className="position-absolute text-400 search-box-icon"
        />
      </Form>
    </Dropdown>
  );
};

export default SearchAreaControl;
